const PREFIX = 'MODAL_' as const;

export const OPEN = `${PREFIX}OPEN` as const;
export const CLOSE = `${PREFIX}CLOSE` as const;

export const PUSH_QUEUE = `${PREFIX}PUSH_QUEUE` as const;
export const POP_QUEUE = `${PREFIX}POP_QUEUE` as const;
